(function() {
    'use strict';
    angular
        .module('valueconnectApp')
        .factory('Holiday', Holiday);

    Holiday.$inject = ['$resource', 'DateUtils'];

    function Holiday ($resource, DateUtils) {
        var resourceUrl =  'api/holidays/:id';

        function convertHolidayDates(holiday) {
            if (holiday) {
                holiday.startDate = DateUtils.convertLocalDateFromServer(holiday.startDate);
                holiday.endDate = DateUtils.convertLocalDateFromServer(holiday.endDate);
            }
            return holiday;
        }

        function transformArrayResponse(data) {
            if (data) {
                data = angular.fromJson(data);
                angular.forEach(data, convertHolidayDates);
            }
            return data;
        }

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                transformResponse: transformArrayResponse
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        convertHolidayDates(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getUpcoming': {
                method: 'GET',
                url:'api/holidays/upcoming',
                isArray: true,
                transformResponse: transformArrayResponse
            }
        });
    }
})();
